module.exports = __webpack_public_path__ + "img/insurance.921f196a.svg";